import PostsList from './posts-list';
import { getUrlQueryArg } from '../../util/url-util';

class PostsListSearch extends PostsList {
	constructor(el) {
		super(el);

		this.formSearchEl = document.querySelector('form#form_filter_search') || this.el.querySelector('form#form_filter_search');
		this.inputEl      = this.formSearchEl ? this.formSearchEl.querySelector('input[type="search"]') : null;
		this.buttonEl     = this.formSearchEl ? this.formSearchEl.querySelector('button[type="submit"]') : null;

		this.filterSearch = (getUrlQueryArg('search', '') || getUrlQueryArg('s', '')).trim();

		this.cardsContainerEl = this.el.querySelector('.posts-list__cards-container');
		this.paginationEl     = this.el.querySelector('.posts-list__pagination');
		this.noResultsEl      = this.el.querySelector('[data-no-results-container]');
		this.loaderEl         = this.el.querySelector('.posts-list__loader-container');

		this.buttonMode = this.filterSearch ? 'clear' : 'search';
		this.setButtonMode(this.buttonMode);

		if (!this.filterSearch) {
			if (this.cardsContainerEl) this.cardsContainerEl.classList.add('hide');
			if (this.paginationEl) this.paginationEl.classList.add('hide');
			if (this.loaderEl) this.loaderEl.classList.add('hide');
			if (this.noResultsEl) this.noResultsEl.classList.add('hide');
		}

		if (this.formSearchEl) {
			this.formSearchEl.addEventListener('submit', (e) => {
				e.preventDefault();
				if (!this.inputEl) return;

				const value = this.inputEl.value.trim();
				const base  = (this.formSearchEl.getAttribute('action') || window.location.pathname).replace(/\/+$/, '') + '/';

				// CLEAR
				if (this.buttonMode === 'clear') {
					window.location.assign('/search/');
					return;
				}

				// EMPTY INPUT
				if (!value) {
					this.inputEl.classList.add('error');
					const originalPlaceholder = this.inputEl.getAttribute('placeholder') || '';
					this.inputEl.value = '';
					this.inputEl.setAttribute('placeholder', 'Please enter a keyword to search.');
					this.inputEl.focus();

					setTimeout(() => {
						this.inputEl.setAttribute('placeholder', originalPlaceholder);
						this.inputEl.classList.remove('error');
					}, 2500);

					this.setButtonMode('search');
					return;
				}

				this.showLoader(true);

				const url = `${base}?s=${encodeURIComponent(value)}`;
				window.location.assign(url);
			});

			if (this.inputEl) {
				this.inputEl.addEventListener('input', () => {
					const val = this.inputEl.value.trim();
					if (!val) {
						this.setButtonMode('search');
					} else if (val !== this.filterSearch) {
						this.setButtonMode('search');
					} else if (this.filterSearch) {
						this.setButtonMode('clear');
					}
				});
			}
		}

		this.setupPagination();
	}

	setupPagination() {
		if (!this.paginationEl) return;
		this.paginationEl.querySelectorAll('a.page-numbers').forEach(a => {
			a.addEventListener('click', (e) => {
				e.preventDefault();
				const href = a.getAttribute('href');
				if (href) {
					this.showLoader(true);
					window.location.assign(href);
				}
			});
		});
	}

	showLoader(show) {
		if (!this.loaderEl) return;
		if (show) this.loaderEl.classList.remove('hide');
		else this.loaderEl.classList.add('hide');
	}

	setButtonMode(mode) {
		this.buttonMode = mode;
		if (!this.buttonEl) return;
		if (mode === 'clear') {
			this.buttonEl.textContent = 'Clear';
			this.buttonEl.setAttribute('aria-label', 'Clear search');
		} else {
			this.buttonEl.textContent = 'Search';
			this.buttonEl.setAttribute('aria-label', 'Search');
		}
	}
}

export default PostsListSearch;
